export enum WorkedStatus {
  NOT_STARTED = "not_started",
  IN_PROGRESS = "in_progress",
  MISSING_CHECKOUT = "missing_checkout",
  COMPLETED = "completed",
  COMPLETED_LATE_START = "completed_late_start",
  COMPLETED_OVERTIME = "completed_overtime",
  COMPLETED_LATE = "late_completed",
  INVALID = "invalid",
}
